import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const useStyles = makeStyles((theme) => ({
  highlightedFilter: {
    // backgroundColor: 'aliceblue',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
  },
}));

const renderMultiSelectValue = (selected, data) => {
  if (selected.length === 0) {
    return <em>Select feature(s)</em>;
  }

  const selectedItem = data.find((item) => item.value === selected[0]);

  if (selected.length === 1) {
    return <Chip label={selectedItem ? selectedItem.name : selected[0]} />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
      <Box
        sx={{
          display: 'flex',
          maxWidth: '150px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        <Chip label={selectedItem ? selectedItem.name : selected[0]} />
      </Box>
      <Chip label={`+${selected.length - 1}`} />
    </Box>
  );
};

export default function SelectBox(props) {
  const {
    name,
    title,
    data,
    value,
    open,
    onChange,
    onClick,
    width,
    height,
    highlighted,
    className,
    disabled = false,
    multiple = false,
    error,
    spacing = false,
  } = props;
  const classes = useStyles();
  const disabledProps = { inputProps: { readOnly: true } };
  return (
    <FormControl
      className={className}
      sx={{
        width: width ?? '100%',
        position: 'relative',
        m: spacing && '8px 0 18px',
        ...(height && { height }),
        ...(disabled && { backgroundColor: '#f5f5f5', pointerEvents: 'none' }),
      }}
    >
      <InputLabel>
        {title}
      </InputLabel>
      {multiple ? (
        <Select
          style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
          multiple
          name={name}
          value={value}
          onChange={onChange}
          className={highlighted ? classes.highlightedFilter : null}
          input={<OutlinedInput label="Chip" />}
          renderValue={(selected) => renderMultiSelectValue(selected, data)}
          {...(disabled && disabledProps)}
        >
          <ListSubheader
            component="div"
            disableSticky
            sx={{
              display: 'flex',
              alignItems: 'center',
              py: 1,
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'primary.lighter',
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              onChange({ target: { value: [] } });
            }}
          >
            <RestartAltIcon color="primary" sx={{ mx: 1 }} />
            <ListItemText primary="Reset Selection" sx={{ color: 'primary.dark' }} />
          </ListSubheader>

          {data && data.length > 0 ? (
            data.map((item) => {
              if (typeof item === 'string') {
                return (
                  <MenuItem key={item} value={item}>
                    <Checkbox checked={value.indexOf(item) > -1} />
                    <ListItemText primary={item} />
                  </MenuItem>
                );
              } if (typeof item === 'object') {
                return (
                  <MenuItem key={item.id} value={item.value}>
                    <Checkbox checked={value.indexOf(item.value) > -1} />
                    <ListItemText primary={item.name} />
                  </MenuItem>
                );
              }
              return null;
            })
          ) : null}
        </Select>
      )
        : (
          <Select
            name={name}
            value={value}
            className={highlighted ? classes.highlightedFilter : null}
            fullWidth
            open={open && open}
            {...(onChange ? { onChange } : { onClick })}
            {...(disabled && disabledProps)}
            sx={{ ...(height && { height }) }}
          >
            {data && data.length > 0 ? (
              data.map((item) => {
                if (typeof item === 'string') {
                  return (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  );
                } if (typeof item === 'object') {
                  return (
                    <MenuItem key={item.id} value={item.value}>
                      {item.name || item.value}
                    </MenuItem>
                  );
                }
                return null;
              })
            ) : null}
          </Select>
        )}
      <FormHelperText error={error} sx={{ position: 'absolute', bottom: '-1.5em' }}>
        {error && error}
      </FormHelperText>
    </FormControl>
  );
}
